import { render, staticRenderFns } from "./AddMachinery.vue?vue&type=template&id=32c28bdc&scoped=true&"
import script from "./AddMachinery.vue?vue&type=script&lang=ts&"
export * from "./AddMachinery.vue?vue&type=script&lang=ts&"
import style0 from "./AddMachinery.vue?vue&type=style&index=0&id=32c28bdc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c28bdc",
  null
  
)

export default component.exports